import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { SgoModulo } from '../../models/sgo-modulo.model';
import { NavigationService } from '../../services/navigation.service';
import { SgoModuloService } from '../../services/sgo-modulo.service';

@Component({
  selector: 'app-sgo-modulo-list',
  templateUrl: './sgo-modulo-list.component.html',
  styleUrls: ['./sgo-modulo-list.component.scss']
})
export class SgoModuloListComponent extends BaseListComponent<SgoModulo> implements OnInit, OnDestroy {

  sgoModuloList: SgoModulo[];

  constructor(
    private myService: SgoModuloService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.sgoModuloList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/projetos/admin-spgg/sgo-modulos/adicionar'];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: any): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error)
      }
    });
  }

  editar(id: number) {
    return ['/projetos/admin-spgg/sgo-modulos/', id];
  }
}
